import React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { LanguageCode } from '@tink/config/src/markets';
import { AppState, ConnectedPropsWithoutDispatch } from '../../stores/redux-store';

export type HelmetProps = PropsFromRedux & {
  languageCode: LanguageCode;
};

export const TinkLinkPageTitlePresenter: React.VFC<HelmetProps> = ({
  clientName,
  languageCode,
}) => {
  return (
    <Helmet
      htmlAttributes={{ lang: languageCode }}
      titleTemplate="%s - Tink Link"
      defaultTitle={clientName}
    >
      <meta name="description" content="Tink Link" />
    </Helmet>
  );
};

/* istanbul ignore next: not testing mapStateToProps */
const mapStateToProps = (state: AppState) => {
  return {
    clientName: state.oauth.description?.clientName,
  };
};

const connector = connect(mapStateToProps);

type PropsFromRedux = ConnectedPropsWithoutDispatch<typeof connector>;

export const TinkLinkPageTitle = connector(TinkLinkPageTitlePresenter);
